import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonSuperComponent } from './common.super';
import { AppConstants } from '../app-constants.service';
import { ConfigurationApiService } from '../../generated/api/configuration/configuration.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./common.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent extends CommonSuperComponent {

    headline = 'Seite nicht gefunden';

    constructor(
        protected override readonly appConstants: AppConstants,
        protected override readonly configurationApiService: ConfigurationApiService,
        protected readonly router: Router
    ) {
        super(appConstants, configurationApiService);
    }

}
